import { useQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'
import { retryUnlessClientError } from '~/shared/lib/api-error'
import { GOLD_SET_QUERY_KEYS } from '../config'
import type { GoldSetDocument } from '../model'

export function useGoldSetDocument(documentKey: string, pass: number) {
  return useQuery({
    queryKey: GOLD_SET_QUERY_KEYS.document(documentKey, pass),
    queryFn: async () => {
      const response = await apiClient.client.get({
        url: '/gold-set/documents/{key}',
        path: { key: documentKey },
        query: { pass },
        throwOnError: true,
      })
      return response.data as GoldSetDocument
    },
    retry: retryUnlessClientError,
  })
}
